import React from "react";
import { Card } from "react-bootstrap";

const CardContainer = ({ children }) => {
  return (
    <Card
      className="border-top-0"
      style={{ borderRadius: "0 0 0.375rem 0.375rem" }}
    >
      <Card.Body>{children}</Card.Body>
    </Card>
  );
};

export default CardContainer;
